import { collection, collectionGroup, getDocs, type QuerySnapshot } from "firebase/firestore";
import { db } from "@/config/firebase";

/**
 * Gemeinsamer Lader: Brauereien (brandAnalyticsService) und Preiskarte
 * brauchen beide ALLE Bars und ALLE Getränke. Ohne Cache lud jeder Wechsel
 * zwischen den Seiten beides erneut.
 * ponytail: Cache im Speicher für 10 Minuten; bei sehr vielen Getränken die
 * Aggregation in eine Cloud Function (Snapshot) verlagern.
 */
const TTL_MS = 10 * 60 * 1000;

let cached: { at: number; promise: Promise<[QuerySnapshot, QuerySnapshot]> } | null = null;

export function getBarsAndDrinks(forceReload = false): Promise<[QuerySnapshot, QuerySnapshot]> {
  if (forceReload || !cached || Date.now() - cached.at > TTL_MS) {
    const promise = Promise.all([
      getDocs(collection(db, "bars")),
      getDocs(collectionGroup(db, "drinks")),
    ]);
    cached = { at: Date.now(), promise };
    // Fehlgeschlagene Ladung nicht cachen.
    promise.catch(() => {
      if (cached?.promise === promise) cached = null;
    });
  }
  return cached.promise;
}
